'use strict';

class DecisionList {
  constructor($location, $window, invoiceService, originatorService) {
    this.$location = $location;
    this.$window = $window;
    this.invoiceService = invoiceService;
    this.originatorService = originatorService;
  }

  $onInit() {
    this.perPage = 25;
    this.decisions = {
      items: [],
      total: 0
    };
    this.page = 1;

    // sorting
    this.predicate = 'number';
    this.reverse = true;
    this.order = (predicate) => {
      this.reverse = this.predicate === predicate ? !this.reverse : false;
      this.predicate = predicate;
    };
    this.originatorService.getConfirm();

    this.load();
  }

  load() {
    this.invoiceService.getDecisionList(this.page, this.perPage)
      .then((resp) => {
        if (resp.data && resp.data.items && resp.data.items.length) {
          this.decisions = resp.data;
          this.decisions.items.forEach((item) => {
            if (item.recipient.name === '(deleted)') {
              item.recipient.name = '(slettet)';
            }
          });
        } else {
          if (!this.$window.sessionStorage.getItem('noDecisions')) {
            this.$window.sessionStorage.setItem('noDecisions', true);
            this.$location.path('/');
          }
        }
      });
  }

  changeLimit(limit) {
    this.perPage = limit;
    this.page = 1;

    this.load();
  }

  nextPage() {
    this.page = this.page + 1;

    this.load();
  }

  prevPage() {
    this.page = this.page - 1;

    this.load();
  }

  numberOfPages() {
    return Math.ceil(this.decisions.total / this.perPage);
  }
}

DecisionList.$inject = ['$location', '$window', 'invoiceService', 'originatorService'];

const decisionList = {
  controller: DecisionList,
  template: `
    <div class="row">
      <div class="large-6 columns">
        <h2>Beslutning kreves</h2>
      </div>
      <div class="large-6 columns right-align">
        <a role="button" class="button" href="#/massekredit">Massekreditnota</a>
        <a role="button" class="button" href="#/massepurring">Massepurring</a>
      </div>
    </div>

    <p class="lead">Oversikt over regninger du m&aring; ta en beslutning om ({{ $ctrl.decisions.total }} stk)</p>

    <div class="row">
      <div class="large-6 columns">
        <p ng-show="$ctrl.decisions.total > 25">
          <a href ng-click="$ctrl.changeLimit(25)">25</a> |
          <a href ng-click="$ctrl.changeLimit(50)">50</a> |
          <a href ng-click="$ctrl.changeLimit(100)">100</a>
        </p>
      </div>
      <div class="large-6 columns">
        <ul ng-show="$ctrl.numberOfPages() > 1" class="pagination right">
          <li class="arrow" ng-show="$ctrl.page > 1"><a href ng-click="$ctrl.prevPage()">&laquo;</a></li>
          <li class="secondary">side <b>{{ $ctrl.page }}</b> av <b>{{ $ctrl.numberOfPages() }}</b></li>
          <li class="arrow" ng-show="$ctrl.page < $ctrl.numberOfPages()"><a href ng-click="$ctrl.nextPage()">&raquo;</a></li>
        </ul>
      </div>
    </div>

    <table ng-class="{ small: $ctrl.decisions.items.length > 20 }" ng-if="$ctrl.decisions.items.length" class="responsive">
      <thead>
        <tr>
          <th></th>
          <th ng-click="$ctrl.order('number')" ng-class="{ sortorder: $ctrl.predicate === 'number', reverse: $ctrl.reverse }">#</th>
          <th ng-click="$ctrl.order('invoiceDate')" ng-class="{ sortorder: $ctrl.predicate === 'invoiceDate', reverse: $ctrl.reverse }">Fakturadato</th>
          <th ng-click="$ctrl.order('dueDate')" ng-class="{ sortorder: $ctrl.predicate === 'dueDate', reverse: $ctrl.reverse }">Forfallsdato</th>
          <th ng-click="$ctrl.order('recipient.name')" ng-class="{ sortorder: $ctrl.predicate === 'recipent.name', reverse: $ctrl.reverse }">Mottager</th>
          <th class="right-align">Fakturabel&oslash;p</th>
          <th class="right-align">Utest&aring;ende</th>
          <th>Beslutning</th>
        </tr>
      </thead>
      <tbody>
        <tr ng-repeat="invoice in $ctrl.decisions.items | orderBy:$ctrl.predicate:$ctrl.reverse track by invoice.number">
          <td><i ng-show="invoice.international" class="icon icon-flag-en left"></i></td>
          <td><a href="#/regning/{{ invoice.number }}">{{ invoice.number }}</a></td>
          <td>{{ invoice.invoiceDate | dateFormat }}</td>
          <td>{{ invoice.dueDate | dateFormat }}</td>
          <td><a href="#/kunde/{{ invoice.recipient.number }}">{{ invoice.recipient.name }}</a></td>
          <td class="nowrap right-align">{{ invoice.total | crowns }}<span ng-if="invoice.currency !== 'NOK'"> / {{ invoice.currency }} {{ invoice.currencyTotal | crowns:false }}</span></td>
          <td class="nowrap right-align">{{ invoice.balance | crowns }}</td>
          <td class="center-align">
            <a href class="button small secondary" ng-click="panel = !panel">Velg <i class="fa fa-caret-down"></i></a>
            <div class="dropdown-container">
            <ul ng-show="panel" class="dropdown-list">
              <li ng-if="invoice._links.sendDunning"><a href="#/purring/kladd/{{ invoice.number }}/send">Send purring</a></li>
              <li><a href="#/regning/{{ invoice.number }}/send">Send p&aring; nytt</a></li>
              <li><a href="#/regning/{{ invoice.number }}/betaling">Registrer betaling</a></li>
              <li ng-if="!invoice.international && invoice.giroLayout"><a href="#/kreditnota/kladd/ny?regning={{ invoice.number }}">Send kreditnota</a></li>
              <li ng-if="!invoice.international && !invoice.giroLayout"><a href="#/kreditnota/kladd/utengiro/ny?regning={{ invoice.number }}">Send kreditnota</a></li>
              <li ng-if="invoice.international"><a href="#/kreditnota/kladd/engelsk/ny?regning={{ invoice.number }}">Send kreditnota</a></li>
              <li ng-if="invoice._links.sendToDebtCollection"><a href="#/inkasso/{{ invoice.number }}/send">Send til inkasso</a></li>
            </ul>

            </div>
          </td>
        </tr>
      </tbody>
    </table>

    <div class="row">
      <div class="large-6 columns">
        <p ng-show="$ctrl.decisions.total > 25">
          <a href ng-click="$ctrl.changeLimit(25)">25</a> |
          <a href ng-click="$ctrl.changeLimit(50)">50</a> |
          <a href ng-click="$ctrl.changeLimit(100)">100</a>
        </p>
      </div>
      <div class="large-6 columns">
        <ul ng-show="$ctrl.numberOfPages() > 1" class="pagination right">
          <li class="arrow" ng-show="$ctrl.page > 1"><a href ng-click="$ctrl.prevPage()">&laquo;</a></li>
          <li class="secondary">side <b>{{ $ctrl.page }}</b> av <b>{{ $ctrl.numberOfPages() }}</b></li>
          <li class="arrow" ng-show="$ctrl.page < $ctrl.numberOfPages()"><a href ng-click="$ctrl.nextPage()">&raquo;</a></li>
        </ul>
      </div>
    </div>
  `
};

angular
  .module('SendRegning')
  .component('decisionList', decisionList)
  .config(($routeProvider) => {
    $routeProvider
      .when('/beslutning-kreves', {
        title: 'Beslutning kreves',
        template: '<decision-list />',
        secure: true
      });
  });
